import layout_bravo_cloud from './bravo_cloud/BravoCloudConfig';

const FuseLayoutConfigs = {
    layout_bravo_cloud,
};

export default FuseLayoutConfigs;
